import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { searchWorkspaceUsers } from "../services/workspaces/workspaceMembersApi";
import type { WorkspaceUserSearchResponse } from "../services/workspaces/workspaceMembers.types";
import { queryKeys } from "../services/queryKeys";

export const MIN_WORKSPACE_USER_SEARCH_LENGTH = 2;

export interface UseWorkspaceUserSearchOptions {
  query: string;
  enabled?: boolean;
  limit?: number;
}

export const useWorkspaceUserSearch = ({
  query,
  enabled = true,
  limit = 10,
}: UseWorkspaceUserSearchOptions) => {
  const trimmed = query.trim();

  return useQuery<WorkspaceUserSearchResponse>({
    queryKey: queryKeys.workspaces.userSearch(trimmed),
    queryFn: () => searchWorkspaceUsers({ q: trimmed, limit }),
    enabled: enabled && trimmed.length >= MIN_WORKSPACE_USER_SEARCH_LENGTH,
    placeholderData: keepPreviousData,
  });
};
